export const ANALYSIS_LOG_PLATFORM = 'web_view'
export const ANALYSIS_LOG_CATEGORY = 'miruLandingPage'

export enum AnalysisLogAction {
  clickedBuyOnAmazon = 'clickedBuyOnAmazon',
  clickedBuyOnRakuten = 'clickedBuyOnRakuten',
  clickedPurchaseStepsButtonAmazon = 'clickedPurchaseStepsButtonAmazon',
  clickedPurchaseStepsButtonRakuten = 'clickedPurchaseStepsButtonRakuten',
  clickedLearnMoreAboutPremium = 'clickedLearnMoreAboutPremium',
  clickedBuyOnAmazonPostPurchaseModal = 'clickedBuyOnAmazonPostPurchaseModal',
  clickedBuyOnRakutenPostPurchaseModal = 'clickedBuyOnRakutenPostPurchaseModal',
  clickedPurchaseStepsButtonAmazonPostPurchaseModal = 'clickedPurchaseStepsButtonAmazonPostPurchaseModal',
  clickedPurchaseStepsButtonRakutenPostPurchaseModal = 'clickedPurchaseStepsButtonRakutenPostPurchaseModal',
  clickedLearnMoreAboutPremiumPostPurchaseModal = 'clickedLearnMoreAboutPremiumPostPurchaseModal',
}
